<template>
  <div class="reply-block d-flex align-items-center rounded text-start w-100"
       :style="{ backgroundColor: background, borderLeft: `3px solid ${borderColor || titleColor}` }">

    <div v-if="preview" class="reply-thumb position-relative rounded overflow-hidden flex-shrink-0 me-2">
      <video v-if="preview.kind === 'video'"
             class="w-100 h-100"
             style="object-fit: cover;"
             :src="'/' + preview.path"
             muted
             playsinline
             preload="metadata"></video>
      <img v-else-if="preview.kind === 'image'"
           class="w-100 h-100"
           style="object-fit: cover;"
           :src="'/' + preview.path"
           alt="" />
      <span v-else class="w-100 h-100 d-flex align-items-center justify-content-center reply-thumb-audio">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
          <path d="M9 2m0 3a3 3 0 0 1 3 -3h0a3 3 0 0 1 3 3v5a3 3 0 0 1 -3 3h0a3 3 0 0 1 -3 -3z" />
          <path d="M5 10a7 7 0 0 0 14 0" />
          <path d="M8 21l8 0" />
          <path d="M12 17l0 4" />
        </svg>
      </span>

      <span v-if="preview.count > 1" class="reply-thumb-count position-absolute">+{{ preview.count - 1 }}</span>
    </div>

    <div class="flex-grow-1 overflow-hidden">
      <strong class="d-block text-truncate" :style="{ color: titleColor }">{{ title }}</strong>
      <div class="text-truncate" :class="text ? 'text-muted' : 'text-secondary fst-italic'">{{ label }}</div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  // { kind: 'image' | 'video' | 'audio', path: String, count: Number }
  preview: { type: Object, default: null },
  title: { type: String, default: '' },
  text: { type: String, default: '' },
  titleColor: { type: String, default: '#0b5ed7' },
  borderColor: { type: String, default: '' },
  background: { type: String, default: 'transparent' }
});

const label = computed(() => {
  if (props.text) return props.text;

  const kind = props.preview?.kind;
  if (kind === 'video') return t('labels.replyVideo', 'Відео');
  if (kind === 'audio') return t('labels.replyVoice', 'Голосове повідомлення');
  if (kind === 'image') {
    const photo = t('labels.replyPhoto', 'Фото');
    return props.preview.count > 1 ? `${photo} (${props.preview.count})` : photo;
  }

  return t('labels.replyMedia', 'Медіа');
});
</script>

<style scoped lang="scss">
.reply-block {
  padding: 5px 8px;
  font-size: 11px;
  line-height: 1.35;
}

.reply-thumb {
  width: 46px;
  height: 46px;
  background-color: rgba(0, 0, 0, 0.06);
}

.reply-thumb-audio {
  color: #6c757d;
}

.reply-thumb-count {
  right: 1px;
  bottom: 1px;
  padding: 0 3px;
  border-radius: 4px;
  font-size: 9px;
  line-height: 12px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.6);
}
</style>
